import React from "react";
import { Descriptions } from "antd";

// 定义描述项数据接口
export interface DescriptionItem {
  key: string;
  label: string | React.ReactNode;
  value?: string | React.ReactNode;
  render?: (value: any) => React.ReactNode;
  span?: number; // 该字段占的格子数
}

// 定义组件属性接口
export interface CompsDescriptionProps {
  data: DescriptionItem[];
  columns?: number; // 默认列数
  bordered?: boolean; // 是否显示边框
  size?: "default" | "middle" | "small";
  labelStyle?: React.CSSProperties; // 已弃用，使用 styles.label
  contentStyle?: React.CSSProperties; // 已弃用，使用 styles.content
  styles?: {
    label?: React.CSSProperties;
    content?: React.CSSProperties;
  };
  layout?: "horizontal" | "vertical"; // 布局方向
  showEmpty?: boolean; // 是否显示空值
  className?: string;
  style?: React.CSSProperties;
}

/**
 * 通用描述组件（内核）
 * 只包含描述列表核心功能，不包含容器
 */
function CompsDescription({
  data,
  columns = 2,
  bordered = false,
  size = "small",
  labelStyle,
  contentStyle,
  styles,
  layout = "horizontal",
  showEmpty = false,
  className,
  style,
}: CompsDescriptionProps): React.ReactElement {
  // 将数据转换为 Descriptions 需要的格式，并处理 span
  const transformedData = data
    .filter((item) => showEmpty || item.value !== undefined)
    .map((item) => {
      let span = item.span || 1;
      // 确保 span 不超过 columns，避免警告
      if (span > columns) {
        span = columns;
      }
      return {
        key: item.key,
        label: item.label,
        children: item.render ? item.render(item.value) : item.value,
        span,
      };
    });

  // 根据 layout 决定 labelStyle
  const finalLabelStyle: React.CSSProperties = {
    ...(labelStyle || styles?.label),
    ...(layout === "vertical" ? { textAlign: "right" } : {}),
  };

  const finalContentStyle: React.CSSProperties = {
    ...(contentStyle || styles?.content),
  };

  // 使用新的 styles API（推荐方式）
  const descriptionStyles = {
    label: finalLabelStyle,
    content: finalContentStyle,
  };

  return (
    <div className={className} style={style}>
      <Descriptions
        bordered={bordered}
        column={columns}
        size={size}
        styles={descriptionStyles}
      >
        {transformedData.map((item) => (
          <Descriptions.Item key={item.key} label={item.label} span={item.span}>
            {item.children}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
}

export default CompsDescription;
